<template>
  <div>
    <!-- <vx-card>
      <div class="form-title">
        <h4>Filters</h4>
      </div>

      <div class="flex flex-wrap items-center justify-between">
        <div class="w-full sm:w-1/2 md:w-1/4 p-1">Salman</div>
        <div class="w-full sm:w-1/2 md:w-1/4 p-1">Salman</div>
        <div class="w-full sm:w-1/2 md:w-1/4 p-1">Salman</div>
        <div class="w-full sm:w-1/2 md:w-1/4 p-1">Salman</div>
        <div class="w-full sm:w-1/2 md:w-1/4 p-1">Salman</div>
        <div class="w-full sm:w-1/2 md:w-1/4 p-1">Salman</div>
        <div class="w-full sm:w-1/2 md:w-1/4 p-1">Salman</div>
      </div>
    </vx-card> -->
    <vx-card>
      <AgGridVue
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="listData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        @cell-clicked="onCellClicked"
      />
    </vx-card>

    <!-- Popups -->

    <!-- Edit/Approve/Reject -->
    <vs-popup
      title="Edit Expense"
      v-if="showActionPopup"
      :active.sync="showActionPopup"
      fullscreen
    >
      <ProjectExpenseAction :purchaseData="singleExpense" />
    </vs-popup>

    <!-- Details -->
    <vs-popup class="holamundo" title="Details" :active.sync="showDetailsPopup">
      <div class="" v-if="singleExpense">
        <div class="flex flex-wrap items-center justify-between mb-5">
          <div class="w-full sm:w-1/2 md:w-1/3 p-1 mb-2">
            <h6>Name:</h6>
            <p>{{ singleExpense.po_name }}</p>
          </div>
          <div class="w-full sm:w-2/3 md:w-2/3 p-1 mb-2">
            <h6>VHC Code:</h6>
            <p>{{ singleExpense.VHC_code }}</p>
          </div>
          <div class="w-full sm:w-1/2 md:w-1/3 p-1 mb-2">
            <h6>Priority:</h6>
            <p>{{ singleExpense.priority_name }}</p>
          </div>
          <div class="w-full sm:w-1/2 md:w-1/3 p-1 mb-2">
            <h6>Description:</h6>
            <p>{{ singleExpense.purchase_description }}</p>
          </div>
          <div class="w-full sm:w-1/2 md:w-1/3 p-1 mb-2">
            <h6>Amount:</h6>
            <p>{{ (singleExpense.total || 0).toLocaleString() }}</p>
          </div>
          <div class="w-full sm:w-1/2 md:w-1/3 p-1 mb-2">
            <h6>GST Name:</h6>
            <p>{{ singleExpense.gst_name }}</p>
          </div>
          <div class="w-full sm:w-1/2 md:w-1/3 p-1 mb-2">
            <h6>GST Amount:</h6>
            <p>{{ (singleExpense.gst_amount || 0).toLocaleString() }}</p>
          </div>
          <div class="w-full sm:w-1/2 md:w-1/3 p-1 mb-2">
            <h6>Total Amount:</h6>
            <p>{{ (singleExpense.total_amount || 0).toLocaleString() }}</p>
          </div>
        </div>

        <div class="">
          <table>
            <thead class="bg-primary">
              <tr>
                <th class="w-64">
                  <h5 class="text-white font-semibold">Line Item</h5>
                </th>
                <th>
                  <h5 class="text-white font-semibold">Vendor</h5>
                </th>
                <th class="w-32">
                  <h5 class="text-white font-semibold text-center">
                    Amount
                  </h5>
                </th>
                <th class="w-64">
                  <h5 class="text-white font-semibold text-center">
                    Description
                  </h5>
                </th>
              </tr>
            </thead>

            <tbody v-if="singleExpense && singleExpense.purchase_lineitems">
              <tr
                v-for="(lineItem, i) of singleExpense.purchase_lineitems"
                :key="`lineItem-${i}`"
              >
                <th class="border p-1">
                  <h6>
                    {{
                      lineItem.parent_category_name +
                        " - " +
                        lineItem.category_name
                    }}
                  </h6>
                </th>
                <td class="border p-1">
                  <h6>
                    {{ lineItem.vendor_name }}
                  </h6>
                </td>
                <td class="border p-1">
                  <p>{{ (lineItem.amount || 0).toLocaleString() }}</p>
                </td>
                <td class="border p-1">
                  <p>{{ lineItem.description }}</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </vs-popup>

    <div v-if="showimageModal == true">
      <image-pop-up :imagePopParamsData="imagePopParamsData"></image-pop-up>
    </div>
  </div>
</template>
<script>
// components
import { AgGridVue } from "ag-grid-vue";
import imagePopUp from "../projects/imagePopUp.vue";
import ProjectExpenseAction from "./ProjectExpenseAction.vue";

// services
import ExpenseService from "@/services/expenseService";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";

export default {
  components: { AgGridVue, imagePopUp, ProjectExpenseAction },
  data() {
    return {
      imagePopParamsData: {},
      showimageModal: false,
      showDetailsPopup: false,
      showActionPopup: false,
      singleExpense: {},
      listData: [],
      gridOptions: {},
      maxPageNumbers: 7,
      gridApi: null,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true,
      },
      paginationPageSize: 7,

      columnDefs: [
        {
          headerName: "Action",
          field: "purchase_id",
          filter: false,
          width: 175,
          pinned: "left",
          sortable: false,
          cellStyle: { "text-align": "center" },
          cellRenderer: function(params) {
            return ' <span class="text-center table-edit-icon" >  <i class="text-center material-icons">edit</i> </span>';
          },
        },
        {
          headerName: "Expense Status",
          field: "purchase_status",
          width: 165,
          filter: true,
          cellRenderer: function(params) {
            if (params.value == 0) {
              return `<span class="rounded p-2 bg-warning font-bold text-white">Pending</span>`;
            } else if (params.value == 1) {
              return `<span class="rounded p-2 bg-success font-bold text-white">Approved</span>`;
            } else if (params.value == 2) {
              return `<span class="rounded p-2 bg-danger font-bold text-white">Rejected</span>`;
            }
          },
        },
        {
          headerName: "VHC Code",
          field: "VHC_code",
          filter: true,
          width: 350,
        },
        {
          headerName: "Details",
          field: "exp_det",
          filter: true,
          width: 150,
          cellRenderer: function(params) {
            return '<span class="text-center table-edit-icon""> <i class="text-center material-icons">remove_red_eye</i>  </span>';
          },
        },
        {
          headerName: "Name",
          field: "po_name",
          minWidth: 200,
          filter: true,
        },

        {
          headerName: "Documents",
          field: "purchase_image",
          filter: true,
          width: 200,
          sortable: false,
          cellRenderer: function(params) {
            return params.data.hasOwnProperty("purchase_image") &&
              params.data.purchase_image != "-"
              ? '<span class="text-center table-edit-icon"> <i class="text-center material-icons">info</i> </span>'
              : '    <span class="text-center">No Images</span>';
          },
        },
        {
          headerName: "Amount",
          field: "total",
          filter: true,
          width: 150,
          cellRenderer(params) {
            return (params.data.total || 0).toLocaleString();
          },
        },
        {
          headerName: "GST Name",
          field: "gst_name",
          width: 200,
          cellRenderer: function(params) {
            return params.data.hasOwnProperty("gst_name") &&
              params.data.gst_name
              ? params.data.gst_name
              : '<span class="rounded p-2 bg-danger font-bold text-white">NA</span>';
          },
        },
        {
          headerName: "GST Amount",
          field: "gst_amount",
          width: 150,
          cellRenderer: function(params) {
            return params.data.hasOwnProperty("gst_id") &&
              params.data.gst_id &&
              params.data.hasOwnProperty("gst_amount")
              ? params.data.gst_amount.toLocaleString()
              : '<span class="rounded p-2 bg-danger font-bold text-white">NA</span>';
          },
        },
        {
          headerName: "Total Amount",
          field: "total_amount",
          filter: true,
          width: 150,
          cellRenderer(params) {
            return (params.data.total_amount || 0).toLocaleString();
          },
        },
        {
          headerName: "Priority",
          field: "priority_name",
          filter: false,
          width: 110,
        },
        {
          headerName: "User",
          field: "user_name",
          minWidth: 200,
          maxWidth: 300,
          filter: true,
        },
        // {
        //   headerName: "Currency",
        //   field: "currency",
        //   filter: true,
        //   width: 150,
        // },
        // {
        //   headerName: "Verified Status",
        //   field: "is_verified",
        //   filter: true,
        //   width: 180,
        //   cellRenderer: function(params) {
        //     return params.value == 1
        //       ? `<span class="rounded p-2 bg-success font-bold text-white">Verified</span>`
        //       : `<span class="rounded p-2 bg-warning font-bold text-white">Not Verified</span>`;
        //   },
        // },
        // {
        //   headerName: "Download",
        //   field: "showlogs",
        //   filter: true,
        //   sortable: false,
        //   width: 140,
        // },
        // {
        //   headerName: "Log",
        //   field: "log",
        //   width: 165,
        //   filter: true,
        //   cellRenderer: function(params) {
        //     return params.data.showlogs >= 1
        //       ? ' <span  class="text-center table-edit-icon" > <i class="text-center material-icons">remove_red_eye</i></span>'
        //       : '  <span class="text-center table-edit-icon greyme" v-else> <i class="text-center material-icons">remove_red_eye</i> </span>';
        //   },
        // },

        {
          headerName: "Description",
          field: "purchase_description",
          filter: true,
          width: 300,
        },
        // {
        //   headerName: "Category",
        //   field: "category_name",
        //   filter: true,
        //   width: 275,
        // },
        // {
        //   headerName: "Sub Category",
        //   field: "sub_category_name",
        //   filter: true,
        //   width: 275,
        // },

        // {
        //   headerName: "City",
        //   field: "city_name",
        //   filter: true,
        //   width: 300,
        // },
        // {
        //   headerName: "TDS Amount",
        //   field: "tds_amount",
        //   filter: true,
        //   width: 150,
        //   hide: true,
        // },
        // {
        //   headerName: "Paid Amount",
        //   field: "tally_paid_amount",
        //   filter: true,
        //   width: 150,
        //   hide: true,
        // },

        // {
        //   headerName: "Tally Error",
        //   field: "export_tally_error",
        //   filter: true,
        //   width: 150,
        //   hide: true,
        // },
      ],
    };
  },
  methods: {
    getListData(page_no = 1) {
      const params = { is_var: 6, page_no };
      ExpenseService.getAdvanceExpense(params)
        .then((response) => {
          console.log(response.data.data);
          if (!response.data.Status) {
            return this.$vs.notify({
              title: "Warning!",
              text: data.Message,
              iconPack: "feather",
              icon: "check_box",
              color: "warning",
            });
          }
          this.listData = response.data.data;
        })
        .catch((error) => {
          console.error("Error: ", error.message);
          this.$vs.notify({
            title: "Error!",
            text: error.message,
            iconPack: "feather",
            icon: "check_box",
            color: "error",
          });
        });
    },

    getSingleAdvanceExpense(purchase_id) {
      ExpenseService.getSingleAdvanceExpense({ purchase_id })
        .then((response) => {
          if (!response.data.Status) {
            this.singleExpense = {};
            return this.$vs.notify({
              title: "Warning!",
              text: data.Message,
              iconPack: "feather",
              icon: "check_box",
              color: "warning",
            });
          }
          this.singleExpense = response.data.data;
        })
        .catch((error) => console.error(error.message));
    },

    onCellClicked(params) {
      console.log("params => ", params);
      if (params.colDef.field == "purchase_id") {
        this.getSingleAdvanceExpense(params.data.purchase_id);
        this.showActionPopup = true;
      }

      if (params.colDef.field == "exp_det") {
        this.getSingleAdvanceExpense(params.data.purchase_id);
        this.showDetailsPopup = true;
      }

      if (
        params.colDef.field == "purchase_image" &&
        params.data.purchase_image &&
        params.data.purchase_image != "-"
      ) {
        this.imagePopParamsData = params;
        this.showimageModal = true;
      }
    },
  },
  beforeMount() {
    this.getListData();
  },
};
</script>
